import { Injectable } from '@angular/core';
import { PwaPushNotificationsUserSettings } from './pwa-push-notifications-user-settings.type';
import { LocalStorageCommonService } from '../local-storage/local-storage-common.service';
import { WindowService } from '../window/window.service';
import { PushNotificationStoredData } from './pwa-push-notification-stored-data.type';

@Injectable({
    providedIn: 'root',
})
export class PwaPushNotificationsLocalStorageService {
    private readonly KEY_PWA_PUSH_NOTIFICATIONS_USER_SETTINGS = 'pwaPushNotificationsUserSettings';
    private readonly KEY_PWA_PUSH_NOTIFICATION_STORED_DATA = 'pushNotificationPayload';
    private localStorage: Storage;
    public constructor(
        private readonly localStorageCommonService: LocalStorageCommonService,
        private readonly window: WindowService,
    ) {
        this.localStorage = this.window.nativeWindow.localStorage;
    }

    public savePwaPushNotificationsUserSettings(settings: PwaPushNotificationsUserSettings): void {
        this.localStorageCommonService.storageSet(this.KEY_PWA_PUSH_NOTIFICATIONS_USER_SETTINGS, settings);
    }

    public getPwaPushNotificationsUserSettings(): PwaPushNotificationsUserSettings | undefined {
        return this.localStorageCommonService.storageGet<PwaPushNotificationsUserSettings>(
            this.KEY_PWA_PUSH_NOTIFICATIONS_USER_SETTINGS,
        );
    }

    public getAndClearPayload(): PushNotificationStoredData | undefined {
        // we are directly accessing localStorage here instead of using localStorageCommonService to circumvent the
        // encryption attempt of that service. The service worker which stores the payload does not have access to the
        // encryption keys and therefore cannot encrypt the payload in the first place.
        const payload = this.localStorage.getItem(this.KEY_PWA_PUSH_NOTIFICATION_STORED_DATA);
        this.localStorage.removeItem(this.KEY_PWA_PUSH_NOTIFICATION_STORED_DATA);

        return payload === null ? undefined : (JSON.parse(payload) as PushNotificationStoredData);
    }
}
